import type { ArtifactPreview } from "~/services/artifacts";

// Preview helpers shared by the artifact renderers. The viewers that read an
// artifact's bytes straight from S3 use `content.url`, which the preview
// service synthesizes for them (see `_INLINE_FETCH_SUFFIXES` in the
// conversations preview service).

export function filenameFromPreview(preview: ArtifactPreview): string {
  const c = preview.content;
  if (c && typeof c === "object" && !Array.isArray(c)) {
    const fileName = (c as { file_name?: unknown }).file_name;
    if (typeof fileName === "string" && fileName) {
      return fileName;
    }
  }
  return preview.filename ?? preview.artifact_name ?? "";
}

// Presigned GET URL present in both owner and shared (token-scoped) previews, so
// a viewer never needs a conversation-scoped download call — which also has no
// shared variant.
export function urlFromPreview(preview: ArtifactPreview): string | null {
  const c = preview.content;
  if (c && typeof c === "object" && !Array.isArray(c)) {
    const url = (c as { url?: unknown }).url;
    if (typeof url === "string" && url) {
      return url;
    }
  }
  return null;
}

// Matches whole suffixes rather than the last dot segment, so compound
// suffixes such as `.protein-features.json` resolve.
export function hasFileSuffix(preview: ArtifactPreview, suffixes: readonly string[]): boolean {
  const filename = filenameFromPreview(preview).toLowerCase();
  return suffixes.some((suffix) => filename.endsWith(suffix));
}
